import * as Styles from "../core/styles";
import {FavoriteAppContainer} from "./ApplicationContainer";
import { useTranslation } from "react-i18next";
import {FavoriteWorkflowContainer} from "./WorkflowContainer";
import {UserCards} from '../user-custom-card/UserCards';
import BannerContainer from "../campaign/BannerContainer";
import OutageNotificationContainer from '../notification/OutageNotificationContainer';
import {Heading} from 'cdk-radial';
import AhaWidget from '../third-party-integration/aha/AhaWidget';
import {AhaPilotWidget} from '../third-party-integration/aha/AhaPilotWidget';

export function MyUnifyContainer() {
  const { t } = useTranslation();

  return (
    <div style={{maxWidth:'1664px',marginBottom:'20px'}}>
      <OutageNotificationContainer/>
      <BannerContainer/>
      <div style={{display: 'flex','justifyContent': 'space-between','flexDirection': 'row' , 'marginBottom':'-40px', 'marginTop':'10px'}}>
          <Heading type="subtitle-1" level={6}>
              {t("tabs.myUnify")}
          </Heading>
        <div style={{display: 'flex', gap: '10px'}}>
          <div style={{display: 'flex'}}>
            <AhaWidget></AhaWidget>
          </div>
          <div style={{display: 'flex'}}>
              <AhaPilotWidget></AhaPilotWidget>
          </div>
        </div>
      </div>
    <Styles.ContentContainer>
      <div>
        <UserCards></UserCards>
      </div>
      <div>
        <Styles.TabSubHeader>
          <Heading type="subtitle-1" level={6}>
            {t("myUnifyTab.myApplications")}
          </Heading>
        </Styles.TabSubHeader>
        <FavoriteAppContainer></FavoriteAppContainer>
      </div>
      <div>
        <Styles.WorkflowSubHeader>
          <Heading type="subtitle-1" level={6}>
              {t("myUnifyTab.myWorkflows")}
          </Heading>
        </Styles.WorkflowSubHeader>
        <FavoriteWorkflowContainer></FavoriteWorkflowContainer>
      </div>
    </Styles.ContentContainer>
    </div>
  );
}

export default MyUnifyContainer;
